import Sidebar from '../../components/Sidebar';
import AuthHeader from '../../components/Header/AuthHeader';
import { Grid, LinearProgress } from '@material-ui/core';
import './index.scss';
import { useState, useEffect, Fragment } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getProfileData } from '../../api/onboarding';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';

const Profile = (props) => {

	const [loading, setLoading] = useState(false);
	const [details, setDetails] = useState({});
	const { sidebar } = useSelector((state) => state.user)

	useEffect(() => {
		fetchProfileData()
	}, []);

	const fetchProfileData = () => {
		setLoading(true);
		getProfileData().then(res => {
			setDetails(res);
			setLoading(false);
		})
	}

	const renderStatusBagde = () => {
		if (details.loanStatus === 'ACTIVE') {
			return <span>Active</span>
		} else if (details.loanStatus === 'UNDER_REVIEW') {
			return <span className="reject">Under Review</span>
		} else {
			return <span className="reject">InActive</span>
		}
	}

	const renderPageContent = () => {
		if (loading) {
			return <div className="loading">
        <CircularProgress />
      </div>
		} else {
			return <div className="profileCon">
				<h4>{details.firstName + ' ' + details.lastName} {renderStatusBagde()}</h4>
				<h5>{details.emailId}</h5>
				<div className="profileInnerCon">
					<h5>Borrower Details</h5>
					<Grid container>
						<Grid item md={6}>
							<ul className="leftBox">
								<li><label>FIRST NAME</label> {details.firstName || '--'}</li>
								<li><label>LAST NAME</label> {details.lastName || '--'}</li>
								<li><label>PAN NUMBER</label> {details.pan || '--'}</li>
								<li><label>MOBILE NUMBER</label> {details.mobileNumber || '--'}</li>
								<li><label>DATE OF BIRTH</label> {details.dateOfBirth || '--'}</li>
							</ul>
						</Grid>
						<Grid item md={6}>
							<ul>
								<li><label>LINE ACTIVE SINCE</label> {details.loanActiveSince ? moment.utc(details.loanActiveSince).tz("Asia/Kolkata").format('DD/MM/yyyy') : '--'}</li>
								<li><label>LINE ACTIVE TILL</label> {details.loanActiveTill ? moment.utc(details.loanActiveTill).tz("Asia/Kolkata").format('DD/MM/yyyy') : '--'}</li>
								<li><label>CREDIT LIMIT</label> {details.creditLimit || '--'}</li>
								{details.partnerEmailId ?
									<li><label>TAX EXPERT </label> {details.partnerEmailId || '--'}</li>
									: 
									''
								}
							</ul>
						</Grid>
					</Grid>
				</div>
			</div>
		}
	}

	return (
		<div className={`layout ${sidebar && 'menu_closed'}`}>
			<div className="layout_sidebar">
				<Sidebar {...props} />
			</div>
			<div className="layout_content">
				<AuthHeader />
				{renderPageContent()}
			</div>
		</div>
	)
}

export default Profile;